<template>
  <div class="pipeline-selector">
    <div class="pipeline-selector__select">
      <Multiselect :value="selectedPipeline" :options="filteredPipelines" :taggable="true" label="Depends On"
        :get-label-callback="s => s.label" placeholder="Select a pipeline" @input="onInput" />
      <Button v-if="selectedPipeline" class="pipeline-selector__clear-button" @click="onInput(null)">Clear</Button>
    </div>
    <TextField v-if="selectedPipeline" :value="value.age" label="Age (days)" type="number" @input="onAgeInput" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Multiselect from '@/components/common/Multiselect.vue';
import TextField from '@/components/common/TextField.vue';
import Button from '@/components/common/Button.vue';
export default {
  name: 'PipelineSelector',
  components: {
    Multiselect,
    TextField,
    Button,
  },
  props: {
    value: {
      type: Object,
      default: () => ({ pipelineId: null, age: null })
    },
    currentPipelineId: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState({
      pipelines: state => state.pipelines.collection
    }),
    filteredPipelines() {
      return this.pipelines
        .filter(pipeline => pipeline._id !== this.currentPipelineId)
        .map(pipeline => ({
          id: pipeline._id,
          label: pipeline.title
        }));
    },
    selectedPipeline() {
      return this.filteredPipelines.find(pipeline => pipeline.id === this.value.pipelineId) || null;
    }
  },
  methods: {
    onInput(selectedPipeline) {
      this.$emit('input', selectedPipeline ? { ...this.value, pipelineId: selectedPipeline.id } : { pipelineId: null, age: null });
    },
    onAgeInput(age) {
      this.$emit('input', { ...this.value, age });
    }
  }
};
</script>
<style lang="scss" scoped>
.pipeline-selector {
  width: 400px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 5px;

  .pipeline-selector__select {
    position: relative;

    .pipeline-selector__clear-button {
      position: absolute;
      right: 0;
      top:-10px;
    }
  }
}
</style>
